import { render } from "./ProcessedDocumentTable.vue?vue&type=template&id=4f8bfe9a&scoped=true"
import script from "./ProcessedDocumentTable.vue?vue&type=script&lang=js"
export * from "./ProcessedDocumentTable.vue?vue&type=script&lang=js"

import "./ProcessedDocumentTable.vue?vue&type=style&index=0&id=4f8bfe9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8bfe9a"]])

export default __exports__